import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useManajemenPengetahuanPendaftarContext } from '../../../controller/admin/manajemen_pengetahuan/pendaftar/index';
import { FaSearch } from 'react-icons/fa';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import Loader from '../../Loader';
import Select from 'react-select';

const Pendaftar = () => {
  const { id } = useParams() as { id: string };
  const history = useHistory();

  const { listData, isLoading, search, page, perPage, jumlahData, status } =
    useManajemenPengetahuanPendaftarContext().state;

  const { fetchData, setPengetahuanPendaftar } =
    useManajemenPengetahuanPendaftarContext().dispatch;

  const columns = [
    {
      name: 'NO.',
      selector: (row, index) => (page - 1) * perPage + index + 1,
      width: '100px',
    },
    {
      name: 'NAMA',
      selector: (row) => row?.user.name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'NIP/NIK',
      selector: (row) => row?.user.nip,
      sortable: true,
      wrap: true,
    },
    {
      name: 'STATUS',
      selector: (row) => row?.is_approved,
      sortable: true,
      wrap: true,
      cell: (row) => {
        const status = row?.is_approved;
        let text = '';
        let color = '';

        if (status === null) {
          text = 'Sedang Verifikasi';
          color = 'orange';
        } else if (status === false) {
          text = 'Ditolak';
          color = 'red';
        } else if (status === true) {
          text = 'Diterima';
          color = 'green';
        }

        return <span style={{ color }}>{text}</span>;
      },
    },
    {
      name: 'AKSI',
      cell: (row) => {
        return (
          <Icon
            as={MdOutlineRemoveRedEye}
            bg="blue.100"
            borderRadius="md"
            p={2}
            color="blue.500"
            boxSize={9}
            cursor="pointer"
            onClick={() =>
              history.push(
                `/admin/manajemen_pengetahuan/${row?.pengetahuan_id}/pendaftar/${row?.id}`
              )
            }
          />
        );
      },
      wrap: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#F2FFFB',
        fontWeight: '900',
        fontSize: '13px',
      },
    },
  };

  useEffect(() => {
    fetchData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, page, perPage, status]);

  const handlePerRowsChangePengajuan = async (newPerPage, page) => {
    setPengetahuanPendaftar('page', page);
    setPengetahuanPendaftar('perPage', newPerPage);
  };

  const handlePageChangePengajuan = (page) => {
    setPengetahuanPendaftar('page', page);
  };

  const optionStatus = [
    {
      label: 'Perlu Verifikasi',
      value: 'PENDING',
    },
    {
      label: 'Ditolak',
      value: 'DITOLAK',
    },
  ];

  return (
    <Box bg="white" p={4}>
      <Alert status="info" my={4} borderRadius="lg">
        <Flex>
          <AlertIcon />
          <Box>
            <AlertDescription>
              Halaman ini digunakan untuk menampilkan daftar peserta
              pengetahuan. Admin dapat meninjau data, melakukan verifikasi,
              serta memperbarui status pendaftaran peserta.
            </AlertDescription>
          </Box>
        </Flex>
      </Alert>
      <Flex
        justifyContent="flex-end"
        alignItems={{ base: 'flex-start', md: 'center' }}
        flexDirection={{ base: 'column', md: 'row' }}
        mb={4}
      >
        <Box w="20%" me={2}>
          <Select
            className="w-full"
            options={optionStatus}
            placeholder="Filter Status"
            onChange={(e) => {
              setPengetahuanPendaftar('status', e?.value);
              setPengetahuanPendaftar('page', 1);
            }}
          />
        </Box>
        <InputGroup w="250px" mt={{ base: 4, md: 0 }}>
          <InputLeftElement pointerEvents="none">
            <FaSearch />
          </InputLeftElement>
          <Input
            type="text"
            placeholder="Cari Disini..."
            onChange={(e) => {
              setPengetahuanPendaftar('search', e.target.value);
              setPengetahuanPendaftar('page', 1);
            }}
            _focus={{
              ring: '1',
              ringColor: 'green.700',
              borderColor: 'green.700',
            }}
          />
        </InputGroup>
      </Flex>
      <DataTable
        data={listData}
        columns={columns}
        customStyles={customStyles}
        pagination
        paginationServer
        onChangeRowsPerPage={handlePerRowsChangePengajuan}
        onChangePage={handlePageChangePengajuan}
        paginationTotalRows={listData.length > 0 ? jumlahData : 0}
        progressPending={isLoading}
        progressComponent={<Loader />}
        noDataComponent="Tidak ada data"
      />
    </Box>
  );
};
export default Pendaftar;
